// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("./../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-changelog-js": () => import("./../src/pages/changelog.js" /* webpackChunkName: "component---src-pages-changelog-js" */),
  "component---src-pages-index-js": () => import("./../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-super-secret-sitemap-js": () => import("./../src/pages/super-secret-sitemap.js" /* webpackChunkName: "component---src-pages-super-secret-sitemap-js" */),
  "component---src-templates-answer-js": () => import("./../src/templates/answer.js" /* webpackChunkName: "component---src-templates-answer-js" */)
}

